import { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";

import { getUserRoleFromToken } from '../utils/getUserRoleFromToken';

const token = localStorage.getItem("token");
const userRole = getUserRoleFromToken(token);
const isAdmin = userRole === "admin";


function HomePage({ isAdmin }) {
  const [status, setStatus] = useState("loading");
  const [clockInTime, setClockInTime] = useState(null);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const token = localStorage.getItem("token");

  // Poll status every 20 seconds (and on mount)
  useEffect(() => {
    fetchStatus();
    const interval = setInterval(fetchStatus, 20000);
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, []);

  const fetchStatus = async () => {
    setError("");
    try {
      const res = await axios.get("/api/time/status", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setStatus(res.data.status);
      setClockInTime(res.data.clock_in || null);
    } catch (err) {
      setError("Could not fetch status. Please log in again.");
    }
  };

  const handleClock = async () => {
    setSubmitting(true);
    setError("");
    try {
      if (status === "clocked_in") {
        await axios.post(
          "/api/time/clockout",
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await axios.post(
          "/api/time/clockin",
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
      await fetchStatus();
    } catch (err) {
      setError(err.response?.data?.message || "Action failed");
    }
    setSubmitting(false);
  };

  // Timer: calculate how long user has been clocked in
  const [since, setSince] = useState("");
  useEffect(() => {
    let interval;
    if (status === "clocked_in" && clockInTime) {
      interval = setInterval(() => {
        const diff = Date.now() - new Date(clockInTime).getTime();
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        setSince(
          `${hours > 0 ? `${hours}h ` : ""}${minutes}m`
        );
      }, 1000);
    } else {
      setSince("");
    }
    return () => clearInterval(interval);
  }, [status, clockInTime]);

  if (status === "loading") {
    return (
      <div className="flex h-screen items-center justify-center">
        <Navbar isAdmin={isAdmin} />  {/* <-- Pass prop! */}
        <div className="text-xl">Loading status…</div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <Navbar isAdmin={isAdmin} /> {/* <-- Pass prop! */}
      <div className="bg-white shadow-xl rounded-2xl p-10 flex flex-col items-center w-full max-w-md mt-20">
        <h2 className="text-2xl font-bold mb-4">Work Time Tracker</h2>
        <div className="mb-6 text-lg text-gray-800 text-center">
          {status === "clocked_in" && (
            <span>
              Clocked in for <span className="font-mono">{since}</span>
            </span>
          )}
          {status === "clocked_out" && (
            <span>Currently clocked out</span>
          )}
        </div>
        <button
          onClick={handleClock}
          disabled={submitting}
          className={`w-60 h-16 text-xl font-semibold rounded-2xl transition
            ${status === "clocked_in"
              ? "bg-red-500 hover:bg-red-600 text-white"
              : "bg-green-500 hover:bg-green-600 text-white"}
            ${submitting ? "opacity-60" : ""}
          `}
        >
          {submitting
            ? "Please wait…"
            : status === "clocked_in"
            ? "Clock out"
            : "Clock in"}
        </button>
        {error && (
          <div className="mt-6 text-red-600 font-semibold">{error}</div>
        )}
      </div>
    </div>
  );
}

export default HomePage;
